import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { OivCoreSharedFacade } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MobiUiMessageLevel } from '@mobi/rwc-ui-components-ng-jslib';
import { TranslationService } from '@mobi/rwc-utils-ng-jslib';

import { MCM_BASE_URL, OIV_BASE_URL } from '../../../util/constant/common';
import { ExceptionDispatchError } from '../../../util/constant/error-message';

@Injectable({
    providedIn: 'root',
})
export class ErrorInterceptorService implements HttpInterceptor {
    oivCoreSharedFacade = inject(OivCoreSharedFacade);
    translationService = inject(TranslationService);
    BASE_URL_LIST: readonly string[] = [OIV_BASE_URL, MCM_BASE_URL];
    #exceptionDispatchErrorSet = new Set<string>(Object.values(ExceptionDispatchError));

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(httpErrorResponse => this.#handleError(httpErrorResponse)));
    }

    #handleError(httpErrorResponse: HttpErrorResponse) {
        if (this.isCheckedBaseUrl(httpErrorResponse.url)) {
            let messageKey = httpErrorResponse.error?.errors?.[0]?.reason || 'oiv.error.general';

            if (httpErrorResponse.status === 403) {
                messageKey = 'oiv.error.forbidden';
            }

            this.translateAndDispatchError(messageKey);
        }

        return throwError(() => httpErrorResponse);
    }

    isCheckedBaseUrl(url: string | null) {
        return this.BASE_URL_LIST.some(baseUrl => url?.toLowerCase().includes(baseUrl.toLowerCase()));
    }

    translateAndDispatchError(messageKey: any) {
        if (!this.#exceptionDispatchErrorSet.has(messageKey)) {
            // Ignore error message keys that needed to be skipped for alert
            this.translationService.translate(messageKey).subscribe(translatedMessage => {
                this.oivCoreSharedFacade.addAlert(translatedMessage, MobiUiMessageLevel.ERROR);
            });
        }
    }
}
